import { render, staticRenderFns } from "./customAggEditorModal.vue?vue&type=template&id=1d6c64ff&scoped=true"
import script from "./customAggEditorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./customAggEditorModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./customAggEditorModal.vue?vue&type=style&index=0&id=1d6c64ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c64ff",
  null
  
)

export default component.exports